<template>
  <div style="padding-bottom: 60px">
    <header>
      <div class="headerDiv" v-on:click="backHistory" @click="">
        <img src="@/assets/img/back.png" alt="">
        <p style="color: #FFFFFF">详情</p>
      </div>
    </header>
    <div class="Carousel">
      <div style="width: 100%;">
        <van-swipe :autoplay="3000" :duration="100" type="card" style="width: 100%;height:100%;margin:1rem auto">
          <!--<van-swipe-item v-for="(image, index) in images" :key="index">-->
          <!--<img style="width: 100%;height: 100%" v-lazy="image" />-->
          <!--{{image}}-->
          <!--</van-swipe-item>-->
          <van-swipe-item v-for="(item,index) in list.goods_photo" :key="index">
            <img :src="item.images" style="width: 100%;height: 100%"/>
            <!--{{item}}-->
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div class="product">
      <p>【{{list.title}}】{{list.subtitle}}</p>
      <p class="productPrice">
        <span v-if="list.is_group==1" class="firstPrice">￥{{list.group_price}}</span>
        <span v-else="" class="firstPrice">￥{{list.price}}</span>
        <span class="lastPrice">￥{{list.original_price}}</span>
      </p>
    </div>
    <div class="product">
      <div class="productType" @click="showPopup">
        <p><span class="productx">选择</span><span class="productg">选择规格</span></p>
        <!--<p class="productPrice"><span class="productImg"></span></p>-->
        <p><span class="productImg"></span></p>
      </div>
      <div class="productType">
        <!--<p>-->
        <!--<span class="productx">发货</span>-->
        <!--<span class="productg">浙江杭州</span>-->
        <!--<span style="padding: 0 10px">|</span>-->
        <!--<span>快递：免邮</span>-->
        <!--</p>-->
        <p><span class="productx">发货</span><span class="productg">浙江杭州 &nbsp;&nbsp;&nbsp;|</span><span
          style="margin-left: 1rem">快递：免邮</span></p>
        <!--<p class="productPrice"><span class="productImg"></span></p>-->
        <p><span class="productImg"></span></p>
      </div>
      <!--<div class="productType">-->
      <!--<p><span class="productx">参数</span><span class="productg">尺寸 面料</span></p>-->
      <!--&lt;!&ndash;<p class="productPrice"><span class="productImg"></span></p>&ndash;&gt;-->
      <!--<p><span class="productImg" ></span></p>-->
      <!--</div>-->
      <!--加入购物车-->
      <van-popup v-model="show" closeable position="bottom" :style="{ height: '70%' }">
        <div>
          <div class="choiceMess">
            <div class="choiceImg">
              <img v-if="itemList.image" style="width: 100%;height: 100%" :src="itemList.image" alt="">
              <img v-else="" style="width: 100%;height: 100%" :src="list.img" alt="">
            </div>
            <div style="margin-left: 1rem">
              <p>{{list.title}}</p>
              <p style="color:#ee0a24" v-if="itemList.price">￥{{toDecimal(itemList.price * value)}}</p>
              <p v-else></p>
            </div>
          </div>
          <div style="padding-left: 1rem;margin-top: 1rem" ref="abc">
            <!--<p>选择{{b}}</p>-->
            <p v-if="typeValue">
              <span class="choiceType">选择类型</span>

            </p>
            <ul @click="getList">
              <li v-if="item.value" v-for="(item,index) in goodsType" v-bind:class="{active:number == index}"
                  @click="change(item,index)">
                <!--{{item.value_text}}-->
                <!--{{index}}-->
                {{item.value}}
              </li>
              {{index}}
            </ul>
          </div>
          <div class="purchaseNum">
            <p>购买数量</p>
            <p>
              <van-stepper v-model="value"/>
            </p>
            <!--<p class="purchaseNum"><span>购买数量</span><span><van-stepper v-model="value" /></span></p>-->
          </div>
        </div>
        <div class="inforName">
          <!--<van-button class="saveBottom" style=""  type="primary" @click="saveCart">确定11</van-button>-->
          <div class="saveBottom" @click="saveCart">确定</div>
        </div>
      </van-popup>
      <!--直接购买-->
      <van-popup v-model="show1" closeable position="bottom" :style="{ height: '70%' }">
        <div>
          <div class="choiceMess">
            <div class="choiceImg">
              <img v-if="itemList.image" style="width: 100%;height: 100%" :src="itemList.image" alt="">
              <img v-else="" style="width: 100%;height: 100%" :src="list.img" alt="">
            </div>
            <div style="margin-left: 1rem">
              <p>{{list.title}}</p>
              <p style="color:#ee0a24" v-if="itemList.price">￥{{toDecimal(itemList.price * value)}}</p>
              <p v-else></p>
            </div>
          </div>
          <div style="padding-left: 1rem;margin-top: 1rem" ref="abc">
            <!--<p>选择{{b}}</p>-->
            <p v-if="typeValue">
              <span class="choiceType">选择类型</span>

            </p>
            <ul @click="getList">
              <li v-if="item.value" v-for="(item,index) in goodsType" v-bind:class="{active:number == index}"
                  @click="change(item,index)">
                <!--{{item.value_text}}-->
                <!--{{index}}-->
                {{item.value}}
              </li>
              {{index}}
            </ul>
          </div>
          <div class="purchaseNum">
            <p>购买数量</p>
            <p>
              <van-stepper v-model="value"/>
            </p>
            <!--<p class="purchaseNum"><span>购买数量</span><span><van-stepper v-model="value" /></span></p>-->
          </div>
        </div>
        <div class="inforName">
          <!--<van-button class="saveBottom" style=""  type="primary" @click="saveCart">确定11</van-button>-->
          <div class="saveBottom" @click="onSubmit(0)">确定</div>
        </div>
      </van-popup>
      <!--活动购买拼团-->
      <van-popup v-model="show2" closeable position="bottom" :style="{ height: '70%' }">
        <div>
          <div class="choiceMess">
            <div class="choiceImg">
              <img v-if="itemList.image" style="width: 100%;height: 100%" :src="itemList.image" alt="">
              <img v-else="" style="width: 100%;height: 100%" :src="list.img" alt="">
            </div>
            <div style="margin-left: 1rem">
              <p>{{list.title}}</p>
              <p style="color:#ee0a24" v-if="list.group_price">￥{{toDecimal(list.group_price * value)}}</p>
              <p v-else></p>
            </div>
          </div>
          <div style="padding-left: 1rem;margin-top: 1rem" ref="abc">
            <!--<p>选择{{b}}</p>-->
            <p v-if="typeValue">
              <span class="choiceType">选择类型</span>

            </p>
            <ul @click="getList">
              <li v-if="item.value" v-for="(item,index) in goodsType" v-bind:class="{active:number == index}"
                  @click="change(item,index)">
                <!--{{item.value_text}}-->
                <!--{{index}}-->
                {{item.value}}
              </li>
              {{index}}
            </ul>
          </div>
          <div class="purchaseNum">
            <p>购买数量</p>
            <p>
              <van-stepper v-model="value"/>
            </p>
            <!--<p class="purchaseNum"><span>购买数量</span><span><van-stepper v-model="value" /></span></p>-->
          </div>
        </div>
        <div class="inforName">
          <!--<van-button class="saveBottom" style=""  type="primary" @click="saveCart">确定11</van-button>-->
          <div class="saveBottom" @click="onSubmit(1)">确定</div>
        </div>
      </van-popup>
    </div>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
    <!--分享弹框-->
    <!--<van-popup v-model="show3" @click="alertShow3" closeable position="bottom" :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }" >拼团弹框-->
    <van-popup v-model="show3" @click="alertShow3" closeable position="bottom"
               :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }"><!--拼团弹框-->
      <div>
        <div style="width: 80%;margin: auto">
          <img style="width: 100%" :src=imgUrl alt="">
        </div>
        <div class="collageBottom">
          <div>
            <p style="background: #07c160" @click.stop="shareShow4">
              <span style="width: 35px;height: 35px"><van-icon name="wechat" color="#fff" size="35px"/></span>
            </p>
            <span style="padding-top: 10px">分享给好友</span>
          </div>
          <div>
            <p>
              <!--<span style="width: 35px;height: 35px"><van-icon name="down" color="#07c160" size="30px"/></span>-->
              <span style="width: 40px;height: 40px"><img width="100%" src="@/assets/img/download.jpg" alt=""></span>
            </p>
            <span style="padding-top: 10px">保存图片</span>
          </div>
          <!--<p style="background: #7c6cd7">-->
          <!--<span style="width: 40px;height: 40px"><van-icon name="down" color="#07c160" size="40px"/></span>-->
          <!--<span>分享给好友</span>-->
          <!--</p>-->
        </div>

        <!--<div>-->
        <!--<img src="@/assets/img/share.png" alt="">-->
        <!--</div>-->
      </div>

    </van-popup>
    <!--分享背景图-->
    <van-popup v-model="show4" @click="alertShow4" closeable position="bottom"
               :style="{ height: '100%',    background: 'rgba(0,0,0,0.1)' }"><!--拼团弹框-->
      <div>


        <img style="width:100%;" src="@/assets/img/share.png" alt="">

      </div>

    </van-popup>

    <div class="product">
      <p>商品详情</p>
      <div style="margin-top: 1rem">
        <div><img v-for="url in list.goods_desc" style="width: 100%;margin-bottom: -4px" :src="url.imgurl" alt="">
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="go" v-if="goShow" v-model="goShow">
        <p>
          <span @click="collageAlert"><van-icon size="25px" name="replay" color="#fff"/></span>
          <!--<span  @click="showShare = true" ><van-icon size="25px" name="replay" color="#fff" /></span>-->
          <span>分享</span>
        </p>
        <p>
          <span><van-icon size="25px" name="wap-home-o" color="#fff"/></span>
          <span style="color: #fff"><router-link style="color: #fff" to="/">回首页</router-link></span>
        </p>
        <!--<p>-->
        <!--<span><van-icon size="25px" name="replay" color="#fff"/></span>-->
        <!--<span>公众号</span>-->
        <!--</p>-->
        <p @click="goLeft">
          <van-icon size="25px" color="#fff" name="arrow"/>
        </p>
        <!--<img style="width: 60px"  @click="href()" src="@/assets/img/go2.png" alt="">-->
      </div>
    </transition>
    <transition name="slide-fade">
      <div class="go" v-if="goShow1" v-model="goShow1">
        <p @click="goRight">
          <van-icon size="25px" color="#fff" name="arrow"/>
        </p>
      </div>
    </transition>


    <van-goods-action v-if="list.is_group==1"><!--活动商品-->
      <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24"/>
      <van-goods-action-icon icon="cart-o" text="购物车" @click="toShopCart"/>
      <!--<van-goods-action-icon icon="star" text="已收藏" color="#ff5000" />-->
      <template #default>
        <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24"/>
        <van-goods-action-icon icon="cart-o" text="购物车" @click="toShopCart"/>
        <div class="collageDivLeft collageDiv" @click="purchase">
          <span>￥{{list.price}}</span>
          <span>单独购买</span>
        </div>
        <div v-if="objArr.shoptid" class="collageDivRight collageDiv" @click="purchaseCollage">
          <span>￥{{list.group_price}}</span>
          <!--<span v-if="objArr.shoptid">{{objArr.shoptid}}加入拼团</span>-->
          <span v-if="ifNum==3">发起拼团</span>
          <span v-if="ifNum==4">发起拼团</span>
          <span  v-else="">加入拼团</span>
        </div>
        <div v-else="" class="collageDivRight collageDiv" @click="purchaseCollage">
          <span>￥{{list.group_price}}</span>
          <!--<span v-if="objArr.shoptid">{{objArr.shoptid}}加入拼团</span>-->
          <!--<span v-if="ifNum==1">{{objArr.shoptid}}加入拼团</span>-->
          <span>发起拼团</span>
        </div>
        <!--{{aaaaaaa}}-->
        <!--<p>aaaaaa{{ifNum}}</p>-->
        <!--<van-goods-action-button type="danger" @click="purchase" text="立即购买" />-->
      </template>
      <!--<van-goods-action-button v-if="list.is_group==1" type="warning "  text='`<div></div>`'  >-->
      <!--<van-goods-action-button v-if="list.is_group==1" type="warning "    text="加入购物车"  />-->
      <!--&lt;!&ndash;<div>1111</div>&ndash;&gt;-->
      <!--<van-goods-action-button v-else="" type="warning " @click="addCart" text="加入购物车" />-->
      <!--<van-goods-action-button type="danger" @click="purchase" text="立即购买" />-->
    </van-goods-action>

    <van-goods-action v-else="">
      <van-goods-action-icon icon="chat-o" text="客服" color="#ee0a24"/>
      <van-goods-action-icon icon="cart-o" text="购物车" @click="toShopCart"/>
      <van-goods-action-button type="warning " @click="addCart" text="加入购物车"/>
      <van-goods-action-button type="danger" @click="purchase" text="立即购买"/>
    </van-goods-action>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Swipe, SwipeItem} from 'vant';

  Vue.use(Swipe);
  Vue.use(SwipeItem);
  //  import Vue from 'vue';
  import {Lazyload} from 'vant'
  import wx from 'weixin-js-sdk';

  Vue.use(Lazyload);
  export default {
    name: 'message',
    data() {
      return {
        msg: '',
        color: "#FFFFFF",
//        color:"#000000",
        bool: true,
        radio: '',
        list: [
          'https://img.yzcdn.cn/vant/apple-1.jpg',
          'https://img.yzcdn.cn/vant/apple-2.jpg',
          'https://img.yzcdn.cn/vant/apple-3.jpg',
        ],
        listData: [],
        arrType: ["5g", "10g", "15g", "20g"],
        goodsType: [],
        show: false,
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        show5: false,
        number: 0,
        value: 1,
        activeClass: 'active',
        itemList: {},
        priceList: {},
        typeValue: "",
        click: 0,
        showShare: false,
        options: [
          {name: '微信', icon: 'wechat'},
          {name: '微博', icon: 'weibo'},
          {name: '复制链接', icon: 'link'},
          {name: '分享海报', icon: 'poster'},
          {name: '二维码', icon: 'qrcode'},
        ],
        appId: '',
        signature: '',
        timestamp: '',
        nonceStr: '',
        details: {
          title: 'https://m.shangshebao.com/tuiguang/bcyl.png', // 分享标题
          desc: '年终狂欢，补充医疗重大优惠劲爆来袭,一年一度,机不可失，你还在等什么赶紧点击购买吧！', // 分享描述
          link: 'https://m.shangshebao.com/test.html?recommendid=90597', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://m.shangshebao.com/tuiguang/bcyl.png', // 分享图标
        },
        objArr: {
          shoptid: "",
//          tjid:"",
//          time:"",
//          goods_id:"",
//          is_group:""
        },
        ifNum: 0,
        titile: "",
        num: "",
        bool: true,
        imgUrl:"",
        goShow:true,
        goShow1:false
      }
    },
    methods: {
      collageAlert() {
        this.show3 = true
        this.openqrcode()
//        this.showShare = true;
      },
      onSelect(option) {
//        Toast(option.name);
        this.showShare = false;
      },
      backHistory() {
        this.$router.go(-1)
      },
      toShopCart() {
        this.$router.push("/newShop")
      },
      showPopup() {
        this.show = true;
      },
      addCart() {
        this.show = true;
      },
      purchase() {//直接购买
        this.show1 = true;
//        this.bool=!this.bool
      },
      purchaseCollage() {//拼团购买
        this.show2 = true;
//        this.bool=!this.bool
      },
//      分享弹框消失
      alertShow3() {
        this.show3 = false
//        alert(2)
      },
      show5Alert(){
        this.show5 = true
      },
      shareShow4() {//分享商品图片
//        alert(1)
        this.shareLink()
        this.show3 = true
        this.show4 = true

      },
      goLeft(){
        this.goShow1=true
        this.goShow=false
      },
      goRight(){
        this.goShow1=false
        this.goShow=true
      },
      openqrcode(){//生成二维码图片
        console.log(new Date())
        var timestamp = Date.parse(new Date());
        this.$api.shopQrCode({
          "goods_id":this.itemList.goods_id,
//          "is_group":1,
//          "time":timestamp,
          "user_id":localStorage.getItem("userid"),
//          "tid":""
        })
          .then(res=>{
            this.imgUrl=res.url
          })
      },
      toDecimal(x) {
        var f = parseFloat(x);
//        console.log(isNaN(f))
        if (isNaN(f)) {
          return false;
        }
        var f = Math.round(x * 100) / 100;
        var s = f.toString();

        var rs = s.indexOf('.');
        if (rs < 0) {
          rs = s.length;
          s += '.';
        }
        while (s.length <= rs + 2) {
          s += '0';
        }
        return s;
      },

      onSubmit(code) {
//        this.ifNum=1
        var bool = true
        let number = 0 //团员满时，需要将团ID置空重新发起拼单
        var _this = this
        if (this.objArr.shoptid) {
//        if (code==1) {
          this.$api.selectPintuanPeople({
            userid: localStorage.getItem("userid"),
            tid: this.objArr.shoptid
          }).then(res => {
            if (res.status == 200) {
              _this.ifNum = 2 //成功
            } else if (res.status == 301) {
              _this.title = "您已参加该团，请下单！"
              _this.ifNum = 1
            } else if (res.status == 300) {
              _this.ifNum = 3
              _this.title = "该团人数已满，请您重新发起拼团！"
              this.objArr.shoptid = ""
            } else if (res.status == 302) {
              _this.ifNum = 4
              _this.title = "团不存在，请重新发起拼团"
              this.objArr.shoptid = ""

            }
            console.log(_this.bool)
            if (_this.ifNum == 3 || this.ifNum == 4) {
              if (this.bool) {
                this.$dialog.alert({
                  title: _this.title,
                  message: '',
                  showCancelButton: true
                }).then(() => {
                  this.bool = false
                  this.show2 = false;
                });
              } else {
                this.$router.push({
                  path: "/orderPage",
                  query: {
                    ref: 2,
                    goodid: this.itemList.goods_id,
                    spec_id: this.itemList.id,
                    stock: this.value,
                    code: code,//code是isgroup 0是直接购买，1是拼团购买
                    shoptid: this.objArr.shoptid
                  }
                })
              }
            } else if (_this.ifNum == 2) {
              this.$router.push({
                path: "/orderPage",
                query: {
                  ref: 2,
                  goodid: this.itemList.goods_id,
                  spec_id: this.itemList.id,
                  stock: this.value,
                  code: code,//code是isgroup 0是直接购买，1是拼团购买
                  shoptid: this.objArr.shoptid
                }
              })
            } else {
              this.$dialog.alert({
                title: _this.title,
                message: '',
                showCancelButton: true
              }).then(() => {
                this.$router.push({
                  path: "/orderPage",
                  query: {
                    ref: 2,
                    goodid: this.itemList.goods_id,
                    spec_id: this.itemList.id,
                    stock: this.value,
                    code: code,//code是isgroup 0是直接购买，1是拼团购买
                    shoptid: this.objArr.shoptid
                  }
                })
              });
            }
          })
        } else {
          localStorage.setItem("goodsId", this.itemList.goods_id)
          localStorage.setItem("code", code)
              this.$router.push({
            path:"/orderPage",
            query:{
              ref:2,
              goodid:this.itemList.goods_id,
              spec_id:this.itemList.id,
              stock:this.value,
              code:code,//code是isgroup 0是直接购买，1是拼团购买
              shoptid:this.objArr.shoptid
            }
          })
        }


      },
      saveCart() {


        this.$api.insertCarts({
          id: this.$route.query.id,
          "data[user_id]": localStorage.getItem("userid"),
          "data[goods_id]": this.itemList.goods_id,
          "data[goods_spec_id]": this.itemList.id,
          "data[title]": this.list.title,
          "data[img]": this.list.img,
          "data[price]": this.itemList.price,
          "data[original_price]": this.itemList.original_price,
          "data[stock]": this.value,
        })
          .then(res => {
            this.$toast("成功添加购物车")
          })
        this.show = false;
      },
      getList(event) {
      },
      change(item, index) {
        this.itemList = item
        this.number = index
      },
      GoodsDetailer() {
        console.log(this.objArr)
        console.log(this.objArr.shoptid)
        if (!this.objArr.shoptid) { //没有拼团ID时置空防止查询拼团时报错
          this.objArr.shoptid = ""
        }
        console.log(this.objArr)
        let id = this.objArr.goods_id
        if (this.objArr.shoptid) { /*活动扫二维码进入时有团ID*/
          id = this.objArr.goods_id
//        } else if(this.$route.query.id) {
        } else if(this.objArr.goods_id) { /*普通分享扫二维码*/
          id = this.objArr.goods_id
        }else { /*首页进入时*/
          id = this.$route.query.id
        }
        this.$api.GoodsDetail({
//          id:this.$route.query.id
          id: id
        })
          .then(res => {
            this.listData = res.data
            this.list = res.data.goods
            this.itemList = this.list.goods_spec[0]
            this.goodsType = this.listData.goods.goods_spec
            this.typeValue = this.listData.goods.goods_spec[0].value
            let setList=JSON.stringify(this.list)
            let href=window.location.href
            localStorage.setItem("list",setList)
            localStorage.setItem("link",href)
            console.log(this.list)
            this.shareLink()
          })
      },
      shareLink() {
        console.log(this.list)
        var href = window.location.href
        var url = encodeURIComponent(href)
        this.$api.shareLink({
          'url': url
        })
          .then(data => {
            wx.config({
              debug: false,
              appId: data.appId,
              timestamp: data.timestamp,
              nonceStr: data.nonceStr,
              signature: data.signature,
              jsApiList: [
                // 所有要调用的 API 都要加到这个列表中
                'checkJsApi',
                'updateAppMessageShareData',
                'updateTimelineShareData'
              ]
            });
            wx.ready(function () {
              wx.updateAppMessageShareData({
//                title: '补充医疗', // 分享标题
                title: '【悦薪多商城】', // 分享标题
                desc: this.list.title, // 分享描述
                link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.list.img, // 分享图标
                success: function () {
//                  alert("你好啊")
                  this.show4 = false
                }
              });
              //需在用户可能点击分享按钮前就先调用
              wx.updateTimelineShareData({
                title: '【悦薪多商城】', // 分享标题
                desc: this.list.title, // 分享描述
                link: href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: this.list.img, // 分享图标
                success: function () {
                  this.show4 = false

                }
              })

            });
          })
      },

      user() {//获取微信头像
        var code = this.getUrlParam('code');
        var local = window.location.href;
        console.log(code);
        var userinfoid;
        var userinfoname;
        var userinfoimg;
        if (code == null || code == '') {
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx7bd203a60100c6d4&redirect_uri=" + encodeURIComponent(local) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
        } else {
          this.$api.getuserinfo({
            'code': code
          }).then(data => {
            localStorage.setItem("headimg",data.data.headimgurl);
            localStorage.setItem("name",data.data.nickname);
          })

        }
      },
      getUrlParam(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let url = window.location.href.split('#')[0]
        console.log(url)
        console.log(reg)
        let search = url.split('?')[1]
        console.log(search)
        if (search) {
          var r = search.substr(0).match(reg)
          if (r !== null) return unescape(r[2])
          return null
        } else {
          return null
        }
      },
      getUrl(name) { //拼团获取当前链接
        let _this = this
//        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        let url = name.split('?')[1]
        let linkUrl = url.split('&')
        let obj = {}
        var title = ""
        var message = ""
        linkUrl.forEach(function (res) {
          title = res.split('=')[0]
          message = res.split('=')[1]
          obj["" + title + ""] = message
        })
        _this.objArr = obj
        console.log(obj)
        this.GoodsDetailer()
      }

    },
    mounted() {

      var href = window.location.href
//      this.getUrl("https://m.shangshebao.com/shop/#/newShopDetail?user_id=90597&shoptid=190&tjid=&time=1629971772000&goods_id=297&is_group=1")
//      this.getUrl("https://m.shangshebao.com/shop/#/newShopDetail?user_id=90597&tjid=&time=1629971772000&goods_id=297&is_group=1")
//      this.getUrl("https://m.shangshebao.com/shop/#/newShopDetail?recommend_user_id=90597&goods_id=293")
      this.getUrl(href)

    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">
  * {
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }

  header {
    width: 100%;
    height: 50px;
    background: #ff2500;
    position: fixed;
    z-index: 200;
    top: 0;
  }

  header img {
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }

  .headerDiv {
    display: flex;
    align-items: center;
    line-height: 50px;
  }

  .headerDiv p {
    margin: auto;
    font-size: 15px;
  }

  .saveBottom {
    width: 100%;
    height: 3rem;
    margin: 0 auto;
    border-radius: 1rem;
    background: -webkit-gradient(linear, left bottom, left top, from(#ff8600), to(#d42300));
    background: linear-gradient(to top, #ff8600, #d42300);
    text-align: center;
    line-height: 3rem;
    color: #ffffff;
  }

  .Carousel {
    margin-top: 50px;
  }

  .product {
    border-bottom: solid 5px #E4E4E4;
    padding: 10px 1rem;
  }

  .product p {
    padding-top: 5px;
  }

  .productPrice {
    margin-top: 10px;
    /*padding-left: 1rem;*/
  }

  .lastPrice {
    margin-left: 1rem;
    text-decoration: line-through;
    color: grey;
    font-size: 14px;
  }

  .firstPrice {
    /*font-size: 22px;*/
    color: #ee0a24;

  }

  .productx {
    color: #c9c9c9;
  }

  .productg {
    margin-left: 1rem;
  }

  .productImg {
    background-image: url(../../assets/img/gonext.png);
    background-repeat: no-repeat;
    background-position: 98% center;
    background-size: 7px 15px;
    padding-right: 1rem;
  }

  .productType {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 0;
    font-size: 14px;
  }

  footer {
    z-index: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: content-box;
    width: 100%;
    /*height: 50px;*/
    background-color: #fff;
    position: fixed;
    bottom: 0;
  }

  .shopCart {
    flex: 1;
    text-align: center;
    padding: 1rem 0;
  }

  .footerDiv {
    width: 30%;
    text-align: center;
    padding: 1rem 0px;
    color: #ffffff;
  }

  .choiceImg {
    width: 80px;
    height: 80px;
  }

  .choiceMess {
    display: flex;
    align-items: flex-end;

    padding: 15px;
  }

  .choiceType {
    width: 80px;

  }

  ul {
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    margin-top: 1rem;
  }

  ul li {
    border: solid 1px #e2e2e2;
    padding: 3px 5px;
    margin-right: 10px;
    margin-top: 10px;
    border-radius: 4px;
    font-size: 13px;
  }

  .active {
    color: red;
  }

  .purchaseNum {
    display: flex;
    justify-content: space-between;
    padding: 1rem;
  }

  .inforName {
    position: fixed;
    bottom: 3px;
    width: 100%;
  }

  /deep/ .van-button--primary {

  }

  .collageDivLeft {

    background: linear-gradient(left, #ffd01e, #ff8917);
    border-top-left-radius: 999px;
    border-bottom-left-radius: 999px;

  }

  .collageDiv {
    width: 100%;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    color: #fff;
    padding: 5px 0;
    line-height: 18px;
  }

  .collageDivRight {

    background: linear-gradient(left, #ff6034, #ee0a24);
    border-top-right-radius: 999px;
    border-bottom-right-radius: 999px;
  }

  .collageDiv span {
    display: block;

  }

  /*右侧分享*/
  .go {
    position: fixed;
    right: 0px;
    border: solid 2px #676767;
    /*border-radius: 100%;*/
    width: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 10px 5px;
    border-radius: 12px 0px 0px 12px;
    bottom: 80px;

  }

  .go img {
    /*width: 60px;*/
  }

  .go p {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 6px 0;
  }

  .go p span {
    display: block;
    font-size: 12px;
    margin: 2px 0;
  }

  /*评团弹框样式*/
  .collageBottom {
    width: 100%;
    background: #fff;
    height: 100px;
    bottom: 0;
    position: absolute;
    border-radius: 10px 10px 0 0;
    display: flex;
    font-size: 13px;
    align-items: center;
    justify-content: space-around;
  }

  .collageBottom p {
    /*background: #7c6cd7;*/
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    text-align: center;
    align-items: center;
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }

  .collageBottom div {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 10px;
  }
  .slide-fade-enter-active {
    transition: all .3s ease;
  }
  .slide-fade-leave-active {
    transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .slide-fade-enter, .slide-fade-leave-to
    /* .slide-fade-leave-active for below version 2.1.8 */ {
    transform: translateX(10px);
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/newShopDetail.vue